export enum ModelChangeType {
  // The Model has not been altered by the user since the Notice-Editor has been loaded
  UNCHANGED = 'unchanged',
  // Only the e-Vergabe specific metadata has been altered by the user and there is no need to send a change-notice
  META_ONLY_CHANGE = 'metaonlychange',
  // The Notice has been altered by the user and can be created / change-notice can be sent
  CHANGED = 'changed',
}
